import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Offers.scss';

const Offers = () => {
  const [offers, setOffers] = useState([]);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    const query = '*[_type == "offers"]';
    const brandsQuery = '*[_type == "brands"]';

    client.fetch(query).then((data) => {
      setOffers(data);
    });

    client.fetch(brandsQuery).then((data) => {
      setBrands(data);
    });
  }, []);

  return (
    <div className="app_offers-contianer">
      <div className="app__offers app__flex">
        {offers.map((offer, index) => (
          <div className="app__offers-item app__flex" key={index}>
            <img src={urlFor(offer.imgurl)} alt={offer.name} />
            <div className="app__offers-content">
              <h4 className="bold-text">{offer.name}</h4>
              <p className="p-text">{offer.feedback.length < 50 ? offer.feedback : `${offer.feedback.slice(0, 63)}...`}</p>
              <h5 className="p-text">You can visit our center to get it</h5>
            </div>
          </div>
        ))}
        <div className="app__offers-brands app__flex">
          {brands.map((brand) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5, type: 'tween' }}
              key={brand._id}
            >
              <img src={urlFor(brand.imgUrl)} alt={brand.name} />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Offers, 'app__offers'),
  'offers',
  'app__primarybg',
);
